'use client'

import { useState } from 'react'
import { GuidedIntroSteps } from '..'
import { toast } from 'sonner'

import { updateUser } from '@/app/actions/user'
import { Button } from '@/components/ui/button'
// import { getClientSideURL } from '@/utilities/getURL'
import { User } from '@/payload-types'
import { cn } from '@/utilities/ui'

export const stepOrders = {
  celebration: {
    order: 0,
    previous: null,
    next: 'profile' as const,
  },
  profile: {
    order: 1,
    previous: null,
    next: 'topics' as const,
  },
  topics: {
    order: 2,
    previous: 'profile' as const,
    next: null,
  },
  // Re-instate subscriptions: add subscriptions entry and wire profile.next / topics.next
}

export type StepDirection = 'next' | 'previous'

export const StepFooter = ({
  user,
  currentStep,
  setCurrentStep,
  onUserUpdated,
  onNext,
}: {
  user: User
  currentStep: GuidedIntroSteps
  setCurrentStep: (step: GuidedIntroSteps, direction?: StepDirection) => void
  onUserUpdated?: (updatedUser?: User) => void | Promise<void>
  onNext?: () => void
}) => {
  const previousStep = stepOrders[currentStep].previous
  const nextStep = stepOrders[currentStep].next
  const final = stepOrders[currentStep].next === null
  const [isLoading, setIsLoading] = useState(false)
  const handlePrevious = () => {
    if (previousStep) {
      setCurrentStep(previousStep as GuidedIntroSteps, 'previous')
    }
  }
  const handleNext = () => {
    if (onNext) {
      onNext()
      return
    }
    if (nextStep) {
      setCurrentStep(nextStep as GuidedIntroSteps, 'next')
    }
  }

  const handleFinish = async () => {
    setIsLoading(true)
    try {
      const res = await updateUser({
        ...user,
        introCompleted: true,
      })

      if (res.status === 'error') {
        throw new Error(res.message)
      }

      const updatedUser = res.data
      await onUserUpdated?.(updatedUser)
      toast.success('Intro completed')
    } catch (error: unknown) {
      toast.error(error instanceof Error ? error.message : 'An unknown error occurred')
    } finally {
      setIsLoading(false)
    }
  }
  return (
    <div
      className={cn(
        'flex w-full p-2 sm:px-4',
        (previousStep && nextStep) || final ? 'justify-between' : 'justify-end',
      )}
    >
      {previousStep && (
        <Button variant="outline" icon={false} onClick={handlePrevious}>
          Previous
        </Button>
      )}
      {nextStep && (
        <div className="flex gap-2">
          {/* <Button variant="outline" icon={false} onClick={handleNext}>
            Skip
          </Button> */}
          <Button variant="accent" onClick={handleNext}>
            Next
          </Button>
        </div>
      )}
      {final && (
        <Button variant="accent" onClick={handleFinish} disabled={isLoading}>
          {isLoading ? 'Wrapping up...' : 'Finish'}
        </Button>
      )}
    </div>
  )
}
